import { SET_TICKETS_FILTERS } from '../actions/filters';
import moment from 'moment';

const initialState = {
    searchText: '',
    status: {},
    company: {},
    dateType: {},
    date:{
        from: moment().subtract(1, 'weeks').startOf('day').toDate(),
        to: moment().endOf('day').toDate()
    },
    answered: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_TICKETS_FILTERS: {
            return {
                ...state,
                searchText: action.payload.searchText,
                status: action.payload.status,
                company: action.payload.company,
                dateType: action.payload.dateType,
                date: action.payload.date,
                answered: action.payload.answered
            };
            
        }
        default:
            return state;
    }
};
